
  import { css } from 'lit';
  export const styles = css`:host{--subtitle-text-color: var(--ig-card-subtitle-text-color, var(--ig-gray-900));--actions-text-color: var(--ig-card-actions-text-color, var(--ig-gray-900));--outline-color: var(--ig-card-outline-color, hsl(from var(--ig-gray-400) h s l/0.54));--ig-theme: material;--ig-theme-variant: light}`;
  